import Api from "./Api.js";

const resource = "/listings";

export default {
  get(filters) {
    return Api.get(`${resource}`, {
      params: filters,
    });
  },
  getLists() {
    return Api.get("/lists/");
  },

  getList(list) {
    return Api.get(`/lists/${list}`);
  },

  deleteList(list) {
    return Api.delete(`/lists/${list}`);
  },

  patchList(list, data) {
    return Api.patch(`/lists/${list}/edit-list`, data);
  },

  postList(list, data) {
    return Api.post(`/lists/${list}`, data);
  },

  postListItem(list, data) {
    return Api.post(`/lists/${list}/create-item`, data);
  },

  patchListItem(list, data) {
    return Api.patch(`/lists/${list}/edit-item`, data);
  },
  deleteListItem(list, data) {
    return Api.patch(`/lists/${list}/delete-item`, data);
  },
};
